import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _TYPES$SET_ACCORDION_;
import * as TYPES from './types';
import { setKeysToFalseExceptKey } from './utils/index';
export default (_TYPES$SET_ACCORDION_ = {}, _defineProperty(_TYPES$SET_ACCORDION_, TYPES.SET_ACCORDION_ITEM, function (state, val) {
  state.productAccordionItems[val] = !state.productAccordionItems[val];
  state.productAccordionItems = setKeysToFalseExceptKey(state.productAccordionItems, val);
}), _defineProperty(_TYPES$SET_ACCORDION_, TYPES.SHOW_ACCORDION_ITEM, function (state, val) {
  state.productAccordionItems[val] = true;
  state.productAccordionItems = setKeysToFalseExceptKey(state.productAccordionItems, val);
}), _defineProperty(_TYPES$SET_ACCORDION_, TYPES.SET_ACCORDION_DESCRIPTION, function (state, isMobile) {
  if (isMobile) {
    state.productAccordionItems.description = false;
  } else {
    state.productAccordionItems.description = true;
  }
}), _TYPES$SET_ACCORDION_);